import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const PacketIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 33 28",
  path: (
    <>
      <Path
        d="M31.4987 7.5L31.0001 12.3711C30.9199 12.8677 30.6203 13.3009 30.1842 13.5513L14.8593 22.5478L14.0688 16.4147L6.94684 6.91691L21.6499 1.12339C22.1606 0.915202 22.7415 0.972875 23.2015 1.27812L30.7756 5.84435C31.3214 6.20587 31.6042 6.85293 31.5001 7.5H31.4987Z"
        fill="none"
        strokeWidth="2.01379"
        strokeMiterlimit="10"
      />
      <Path
        d="M6.94688 6.91797L2.43711 7.88435C1.87725 8.00392 1.53262 8.56799 1.68032 9.12081L2.29644 11.4193C2.41319 11.8568 2.80987 12.1606 3.26282 12.1606H7.73884L6.94688 6.91797Z"
        fill="none"
        strokeWidth="2.01379"
        strokeLinejoin="round"
      />
      <Path
        d="M14.8591 22.5471L12.0261 25.6306C11.7996 25.8767 11.3903 25.7712 11.3115 25.4463L11.064 24.4279L10.7573 23.1675C10.6602 22.7694 10.7193 22.3488 10.9205 21.9915L12.669 18.894L14.0686 16.4141L14.8591 22.5471Z"
        fill="none"
        strokeWidth="2.01379"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.9981 24.1576L7.91051 25.8695C6.96101 26.3956 5.76394 26.058 5.23081 25.1128L1.25556 18.071C0.718218 17.1187 1.05582 15.9103 2.00954 15.3744L7.73749 12.1602L12.6693 18.8939"
        fill="none"
        strokeWidth="2.01379"
        strokeMiterlimit="10"
      />
      <Path
        d="M31.5001 7L14.0689 16.4138"
        fill="none"
        strokeWidth="2.01379"
        strokeMiterlimit="10"
      />
    </>
  ),
});

PacketIcon.displayName = "PacketIcon";
export { PacketIcon };
